import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Tip } from 'grommet';
import { Inspect } from 'grommet-icons';

export const ResumeReviewerDisplay = ({ resumeReviewer }) => {
    const firstName =
        resumeReviewer.attributes.user?.data?.attributes?.firstName ??
        '[Missing]';
    const lastName =
        resumeReviewer.attributes.user?.data?.attributes?.lastName ??
        '[Missing]';

    return (
        <Box direction="row" gap="small" justify="start">
            <Tip content="Resume Reviewer">
                <Inspect color="black" />
            </Tip>
            {firstName || lastName ? (
                <Text>
                    {firstName} {lastName}
                </Text>
            ) : (
                <Text>Reviewer has no name</Text>
            )}
        </Box>
    );
};

ResumeReviewerDisplay.propTypes = {
    resumeReviewer: PropTypes.object,
};
